export default __webpack_public_path__ + "partner_1409915b.png";